import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { utils } from '@cofit/api';
import dayjs from 'dayjs';
import * as R from 'ramda';
import { CALORIE_PER_KG, NutritionConstant } from 'src/constants/diet';
import { FoodNoteItem3NutritionQuickAddKind, FoodNoteItemCalorieQuickAddKind, FoodNoteItemQuickAddType, FoodNoteItemType, SIX_FOOD_CATEGORY, TargetType } from 'src/types';
import { pickSixFoodAttributes } from '../diet';
import { getFoodNoteItemCalorieQuickAddKindAttr } from './converter';
export var isSixFoodCategoryExceedTarget = function isSixFoodCategoryExceedTarget(category) {
  if (category.key === SIX_FOOD_CATEGORY.vegetables) {
    return false;
  }

  return category.ingested > category.target;
};
export var getDaysDiff = function getDaysDiff(start, end) {
  return dayjs(end).isBefore(start) ? 1 : dayjs(end).diff(start, 'days') + 1;
};
/**
 * get suggest calorie
 * @param ee energy expenditure, human body needs to maintain its weight, in kcal
 * @param weekly average weekly weight difference, kg
 * @param kg target type
 * @returns calorie, kcal
 */

export var getSuggestCalorie = function getSuggestCalorie(ee, weekly, kg) {
  var calorie = ee;
  var calorieDeltaPerDay = weekly / 7 * CALORIE_PER_KG;

  if (kg === TargetType.LOSE_WEIGHT) {
    calorie -= calorieDeltaPerDay;
  } else if (kg === TargetType.GAIN_WEIGHT) {
    calorie += calorieDeltaPerDay;
  }

  return calorie.toFixed(1);
};
/**
 * get average weekly weight difference
 * @param start_weight start weight, kg
 * @param target_weight target weight, kg
 * @param dateDiff target date difference
 * @returns kg
 */

export var getWeekly = function getWeekly(start_weight, target_weight, dateDiff) {
  return (Math.abs(target_weight - start_weight) / dateDiff * 7).toFixed(2);
};
export var sixGroupsToMacros = function sixGroupsToMacros(sixGroups) {
  var protein = 0;
  var carbohydrate = 0;
  var fat = 0;

  for (var _i = 0, _Object$keys = Object.keys(sixGroups); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var value = sixGroups[key] ? sixGroups[key] : 0;
    protein += value * NutritionConstant.SIX_CATEGORY_TO_MACROS[key].protein;
    carbohydrate += value * NutritionConstant.SIX_CATEGORY_TO_MACROS[key].carbohydrate;
    fat += value * NutritionConstant.SIX_CATEGORY_TO_MACROS[key].fat;
  }

  return {
    protein: protein,
    carbohydrate: carbohydrate,
    fat: fat
  };
};
export var calcCalorieByMacros = function calcCalorieByMacros() {
  var protein = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var carbohydrate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var fat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var sugar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return utils.Util.round((protein || 0) * 4 + (carbohydrate || 0) * 4 + (fat || 0) * 9 + (sugar || 0) * 4, 2);
};
export var calcMacrosPercentage = function calcMacrosPercentage() {
  var protein = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var carbohydrate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var fat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var refined_sugar = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var pos = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
  var calorie = calcCalorieByMacros(protein, carbohydrate, fat);
  var proteinPercentage = 0;
  var carbohydratePercentage = 0;
  var fatPercentage = 0;
  var refined_sugarPercentage = 0;
  proteinPercentage = calorie === 0 ? 0 : utils.Util.round(protein * 4 / calorie * 100, pos);
  carbohydratePercentage = calorie === 0 ? 0 : utils.Util.round(carbohydrate * 4 / calorie * 100, pos);
  refined_sugarPercentage = calorie === 0 ? 0 : utils.Util.round(refined_sugar * 4 / calorie * 100, pos);
  fatPercentage = calorie === 0 ? 0 : utils.Util.round(100 - proteinPercentage - carbohydratePercentage, pos);
  return {
    protein_percentage: proteinPercentage,
    carbohydrate_percentage: carbohydratePercentage,
    fat_percentage: fatPercentage,
    refined_sugar_percentage: refined_sugarPercentage
  };
};
export var calcNutrients = function calcNutrients(type, amount, item) {
  var pos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  switch (true) {
    case type === 'calorie':
      return utils.Util.round(item[type] * amount * item.multiply_ratio, pos);

    case R.includes(type, NutritionConstant.SIXGROUPS):
      return calcSixGroupWeight(type, amount, item);

    case type === 'fatty_acids_total_polyunsaturated':
    case type === 'fatty_acids_total_monounsaturated':
      return utils.Util.round(item.fat * item[type] / 100, 1);
  }

  var val = R.has(type, item) ? utils.Util.round(item[type] * amount * item.multiply_ratio, pos) : 0;
  return val < 0 ? 0 : val;
};

var calcSixGroupWeight = function calcSixGroupWeight(type, amount, item) {
  if (!item[type]) {
    return 0;
  }

  if (item.display_factor === 2 && item.six_group_factor === 1) {
    return utils.Util.round(item[type] * amount * item.serving_weight / item.ex_weight);
  }

  return utils.Util.round(item[type] * amount);
};

export var calcC63PByFoodStuffs = function calcC63PByFoodStuffs(amount) {
  var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _item$macros = item.macros,
      macros = _item$macros === void 0 ? {} : _item$macros,
      _item$six_groups = item.six_groups,
      six_groups = _item$six_groups === void 0 ? {} : _item$six_groups;

  var itemToCal = _objectSpread(_objectSpread(_objectSpread({}, item), macros), six_groups);

  var macrosPercentage = calcMacrosPercentage(itemToCal.protein, itemToCal.carbohydrate, itemToCal.fat, 0, 0);
  var result = R.reduce(function (memo, type) {
    var typeVal = calcNutrients(type, amount, itemToCal, 2);
    return _objectSpread(_objectSpread({}, memo), typeVal ? _defineProperty({}, type, typeVal) : {});
  }, {}, NutritionConstant.C63);
  return _objectSpread(_objectSpread({}, result), macrosPercentage);
};
export var calcC63PBySixGroups = function calcC63PBySixGroups(sixGroups) {
  var _sixGroupsToMacros = sixGroupsToMacros(pickSixFoodAttributes(sixGroups)),
      protein = _sixGroupsToMacros.protein,
      carbohydrate = _sixGroupsToMacros.carbohydrate,
      fat = _sixGroupsToMacros.fat;

  var macrosPercentage = calcMacrosPercentage(protein, carbohydrate, fat, 0, 0);
  var calorie = calcCalorieByMacros(protein, carbohydrate, fat);
  return _objectSpread(_objectSpread({}, sixGroups), {}, {
    calorie: calorie,
    protein: protein,
    carbohydrate: carbohydrate,
    fat: fat
  }, macrosPercentage);
};
export var calcC63PByCalorieItem = function calcC63PByCalorieItem(item) {
  var item_amount = item.item_amount,
      kind = item.kind;
  var isProtein = kind === FoodNoteItemCalorieQuickAddKind.protein;
  var isSugar = kind === FoodNoteItemCalorieQuickAddKind.sugar;
  var isFat = kind === FoodNoteItemCalorieQuickAddKind.fat;
  var protein = isProtein ? item_amount : undefined;
  var carbohydrate = isSugar ? item_amount : undefined;
  var fat = isFat ? item_amount : undefined;
  return _objectSpread(_objectSpread({}, item), {}, {
    protein: protein,
    carbohydrate: carbohydrate,
    fat: fat
  });
};
export var calcC63PBy3NutritionItem = function calcC63PBy3NutritionItem(item) {
  var item_amount = item.item_amount,
      kind = item.kind;
  var isProtein = kind === FoodNoteItem3NutritionQuickAddKind.protein;
  var isSugar = kind === FoodNoteItem3NutritionQuickAddKind.sugar;
  var isRefinedSugar = kind === FoodNoteItem3NutritionQuickAddKind.refined_sugar;
  var isFat = kind === FoodNoteItem3NutritionQuickAddKind.fat;
  var protein = isProtein ? item_amount : undefined;
  var carbohydrate = isSugar || isRefinedSugar ? item_amount : undefined;
  var fat = isFat ? item_amount : undefined;
  var refined_sugar = isRefinedSugar ? item_amount : undefined;
  return _objectSpread(_objectSpread({}, item), {}, {
    protein: protein,
    carbohydrate: carbohydrate,
    fat: fat,
    refined_sugar: refined_sugar
  });
};
export var sumC63 = function sumC63(items) {
  return R.reduce(function (sum, nutrient) {
    sum[nutrient] = 0;
    R.forEach(function (item) {
      sum[nutrient] += Number.parseFloat(item[nutrient] || 0);
    }, items);
    return sum;
  }, {}, NutritionConstant.C63);
};
export var calcItemAmountFromCalorieOr3NutritionQuickAddItem = function calcItemAmountFromCalorieOr3NutritionQuickAddItem(item) {
  var calorie = item.calorie,
      kind = item.kind,
      item_amount = item.item_amount;

  if (kind === FoodNoteItemCalorieQuickAddKind.custom) {
    return '';
  }

  var attr = getFoodNoteItemCalorieQuickAddKindAttr(item);

  if (attr) {
    return utils.Util.round(calorie / attr.calorie);
  }

  return item_amount;
};
export var updateCalorieOr3NutritionQuickAddItemWithCalorie = function updateCalorieOr3NutritionQuickAddItemWithCalorie(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    item_amount: calcItemAmountFromCalorieOr3NutritionQuickAddItem(item)
  });
};
export var calcCalorieFromCalorieOr3NutritionQuickAddItem = function calcCalorieFromCalorieOr3NutritionQuickAddItem(item) {
  var _item$item_amount = item.item_amount,
      item_amount = _item$item_amount === void 0 ? 0 : _item$item_amount,
      kind = item.kind,
      calorie = item.calorie;

  if (kind === FoodNoteItemCalorieQuickAddKind.custom) {
    return calorie;
  }

  var attr = getFoodNoteItemCalorieQuickAddKindAttr(item);

  if (attr) {
    return utils.Util.round(item_amount * attr.calorie);
  }

  return calorie;
};
export var updateCalorieOr3NutritionQuickAddItemWithItemAmount = function updateCalorieOr3NutritionQuickAddItemWithItemAmount(item) {
  return _objectSpread(_objectSpread({}, item), {}, {
    calorie: calcCalorieFromCalorieOr3NutritionQuickAddItem(item)
  });
};
export var updateEmptyQuickItemName = function updateEmptyQuickItemName(item, defaultName) {
  return _objectSpread(_objectSpread({}, item), {}, {
    item_name: item.item_name || defaultName
  });
};
export var updateItemsWithSixGroup = function updateItemsWithSixGroup() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var item = arguments.length > 1 ? arguments[1] : undefined;
  var index = R.findIndex(R.propEq('added_at', item === null || item === void 0 ? void 0 : item.added_at))(items);

  if (!(item !== null && item !== void 0 && item.added_at) && !(item !== null && item !== void 0 && item.add)) {
    index = R.findIndex(R.propEq('created_at', item === null || item === void 0 ? void 0 : item.created_at))(items);
  }

  var itemsToUpdate;
  var added_at = dayjs().format('YYYY-MM-DD HH:mm:ss');

  if (index > -1) {
    itemsToUpdate = [].concat(_toConsumableArray(items.slice(0, index)), [_objectSpread(_objectSpread(_objectSpread({}, items[index]), item), {}, {
      _destroy: false,
      _dirty: true,
      added_at: added_at
    })], _toConsumableArray(items.slice(index + 1)));
  } else {
    itemsToUpdate = [].concat(_toConsumableArray(items), [_objectSpread(_objectSpread({
      item_type: FoodNoteItemType.quickAdd,
      item_id: 1,
      quick_add_type: FoodNoteItemQuickAddType.sixGroup
    }, item), {}, {
      added_at: added_at,
      amount: 1
    })]);
  }

  return itemsToUpdate;
};